var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('navbar'),_c('v-main',{staticClass:"grey lighten-3"},[(_vm.processingRequest)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"red"}}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }